import * as React from 'react';
import Profile from 'src/models/Profile';
import { generatorView } from '../../../../constants/profileSettings';
import GeneratorEntity from '../../../../models/Generator';
import { CardView } from './CardView';
import { ListView } from './ListView';


interface IProps {
  generatorList: GeneratorEntity[]
  view: string
  showDragUi: boolean

  delete: (generator: GeneratorEntity) => void
  run: (generator: GeneratorEntity) => void
  validator: (generator: GeneratorEntity) => void
  profile: Profile
  download: (gen: GeneratorEntity) => void;
  openTokenModalForGenerator: (gen: GeneratorEntity) => void;
}

export const GeneratorView: React.SFC<IProps> = props => {
  const view = (props.view === generatorView.cardView
    ? <CardView 
        showDragUi={props.showDragUi} 
        generators={props.generatorList} 
        validator={props.validator} 
        profile={props.profile} 
        delete={props.delete} 
        run={props.run} 
        download={props.download}
        openTokenModalForGenerator={props.openTokenModalForGenerator}
      />
    : <ListView 
        generators={props.generatorList} 
        validator={props.validator} 
        profile={props.profile} 
        delete={props.delete} 
        run={props.run}
        openTokenModalForGenerator={props.openTokenModalForGenerator}
      />)

  return (
    <div className="columns is-multiline">
      {view}
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorView/index.tsx